import { registerForm } from 'app/schema-form/actions';
import { all, fork, put, race, take } from 'redux-saga/effects';
import { CANCEL, SHOW_FORM, SUBMIT } from './action-types';

function* handleFormDialog() {
  while (true) {
    const { meta, payload } = yield take(SHOW_FORM);
    const { formName, schema, initialData } = payload;

    yield put(registerForm(formName, schema, initialData));

    const { submit } = yield race({
      submit: take(SUBMIT),
      cancel: take(CANCEL)
    });

    if (meta?.callback) {
      setTimeout(() => {
        if (submit) {
          meta.callback(submit.payload.formData);
        }
      }, 0);
    }
  }
}

export default function* root() {
  yield all([fork(handleFormDialog)]);
}
